import { ChevronNextIcon, ChevronPrevIcon } from '@svgs'
import clsx from 'clsx'
import React, { FC } from 'react'
import Button from '../button/Button'

interface IMyPagination {
  totalPages: number
  currentPage: number
  onPageChange: (page: number) => void
  className?: string
}

const MyPagination: FC<IMyPagination> = ({ totalPages, currentPage, onPageChange, className }) => {
  // Nothing to paginate through with a single page — the controls only added
  // visual noise under short lists (owner feedback E1).
  if (totalPages <= 1) return null

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }

  const renderPageNumbers = () => {
    const pages = []
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          className={clsx(
            'flex flex-col justify-center items-center text-center px-1 w-10 h-[1.875rem] rounded-2xl transition-all duration-300 fill-ink hover:fill-brand text-ink hover:text-brand whitespace-nowrap',
            currentPage === i && 'bg-ink !text-surface pointer-events-none',
          )}
        >
          {i}
        </button>,
      )
    }
    return pages
  }

  return (
    <nav className={clsx('flex items-center justify-center self-center flex-wrap', className)}>
      <Button
        variant="empty"
        onClick={handlePrevPage}
        disabled={currentPage === 1}
        className="flex flex-col justify-center items-center text-center px-1 w-10 h-[1.875rem] rounded-2xl transition-all duration-300 fill-ink hover:fill-brand text-ink hover:text-brand"
      >
        <span className="icon-button">
          <ChevronPrevIcon />
        </span>
      </Button>
      <div className="flex items-center justify-center text-xs font-normal">
        {renderPageNumbers()}
      </div>
      <Button
        variant="empty"
        onClick={handleNextPage}
        disabled={currentPage >= totalPages}
        className="flex flex-col justify-center items-center text-center px-1 w-10 h-[1.875rem] rounded-2xl transition-all duration-300 fill-ink hover:fill-brand text-ink hover:text-brand"
      >
        <span className="icon-button">
          <ChevronNextIcon />
        </span>
      </Button>
    </nav>
  )
}

export default MyPagination
